import request from '@/utils/request'

let TaskApi = {
  /*列表*/
   taskList(data, errorback) {
    return request._post('/shop/plus.quest.task/index', data, errorback);
  },
  /*添加*/
  addTask(data, errorback) {
    return request._post('/shop/plus.quest.task/add', data, errorback);
  },
  /*获取数据*/
  getTask(data, errorback) {
    return request._get('/shop/plus.quest.task/edit', data, errorback);
  },

  /*保存*/
  saveTask(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.quest.task/edit', data, errorback);
  },
  /*删除*/
  delTask(data, errorback) {
    return request._post('/shop/plus.quest.task/delete', data, errorback);
  },

}
export default TaskApi;



// WEBPACK FOOTER //
// ./src/api/task.js